import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {Divider, MenuItem} from '@mui/material';
import {HelpOutline as HelpOutlineIcon} from '@mui/icons-material';

import MenuLink from './NavMenuLink.jsx';
import NavMenuButton from './NavMenuButton.jsx';
import TermsDialog from './TermsDialog.jsx';

/**
 * A help menu component for the NavBar that contains links to helpful Planet resources and documentation.
 * The default menu item is a link to https://support.planet.com
 */
const HelpMenu = ({children}) => {
  const [termsOpen, setTermsOpen] = useState(false);

  return (
    <>
      <NavMenuButton title="Help" label={<HelpOutlineIcon fontSize="small" />}>
        <MenuLink href="https://support.planet.com">Help Center</MenuLink>
        <MenuLink href="https://developers.planet.com/">Documentation</MenuLink>
        <MenuItem
          onClick={() => {
            setTermsOpen(true);
          }}
        >
          Terms of Service
        </MenuItem>
        {children}
        <Divider />
        <MenuLink href="https://community.planet.com/ideas">
          Submit feedback
        </MenuLink>
      </NavMenuButton>

      <TermsDialog
        open={termsOpen}
        onClose={() => {
          setTermsOpen(false);
        }}
      />
    </>
  );
};

HelpMenu.propTypes = {
  /**
   Contents of the menu
  */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default HelpMenu;
